import { render, staticRenderFns } from "./RevCard.vue?vue&type=template&id=275f0332&scoped=true"
import script from "./RevCard.vue?vue&type=script&lang=js"
export * from "./RevCard.vue?vue&type=script&lang=js"
import style0 from "./RevCard.vue?vue&type=style&index=0&id=275f0332&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275f0332",
  null
  
)

export default component.exports